import { render, staticRenderFns } from "./SizeAndPriceTable.vue?vue&type=template&id=20bc4b00"
import script from "./SizeAndPriceTable.vue?vue&type=script&lang=ts"
export * from "./SizeAndPriceTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports